import {
   ADD_SETUP_FORMATS,
   DELETE_SETUP_FORMATS,
   GET_ONE_CUSTOMER,
   GET_ONE_SETUP,
   GET_SETUP_FORMATS,
   UPDATE_SETUP_FORMATS,
   SETUP_FORMAT_CUSTOM_QUERY,
} from '../types';

const setupPrint = { list: [], single: null, customQuery: [] };

const reducer = (state = setupPrint, action) => {
   const { type, payload } = action;

   switch (type) {
      case GET_SETUP_FORMATS:
         return { ...state, list: payload };

      case UPDATE_SETUP_FORMATS:
         return {
            ...state,
            list: state.list.map((item) => (item.id === payload.id ? payload : item)),
         };

      case ADD_SETUP_FORMATS:
         return {
            ...state,
            list: [payload, ...state.list],
         };

      case DELETE_SETUP_FORMATS:
         return {
            ...state,
            list: state.list.filter((item) => item.id !== payload.id),
         };

      case GET_ONE_SETUP:
         return { ...state, single: payload };

      case SETUP_FORMAT_CUSTOM_QUERY:
         return { ...state, customQuery: payload, result: payload };

      default:
         return state;
   }
};

export default reducer;
